import { useEffect, useRef } from 'react';
import { Link } from 'react-router';

interface OrderActionResultDialogProps {
  title: string;
  message: string;
  actionLabel: string;
  to: string;
  onAction?: () => void;
}

export function OrderActionResultDialog({
  title,
  message,
  actionLabel,
  to,
  onAction,
}: OrderActionResultDialogProps) {
  const actionLinkRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    actionLinkRef.current?.focus();
  }, []);

  return (
    <div className="md-review-dialog" role="presentation">
      <section
        className="md-review-dialog__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="order-action-result-title"
        aria-describedby="order-action-result-message"
      >
        <div className="md-review-dialog__header">
          <h2 id="order-action-result-title">{title}</h2>
        </div>
        <p id="order-action-result-message" className="md-review-dialog__description">
          {message}
        </p>
        <div className="md-review-dialog__actions">
          <Link ref={actionLinkRef} className="zs-button" to={to} onClick={onAction}>
            {actionLabel}
          </Link>
        </div>
      </section>
    </div>
  );
}
